module.exports = __webpack_public_path__ + "img/logo_fomaqro.bbecd8ac.png";